// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kLjb6","buttons":"Footer_buttons__3nYMt"};